// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1nX5T","gradentText":"style_gradentText__3K2H7"};